var map = {
	"./allfiredup.json": [
		8938,
		938
	],
	"./asktronaut.json": [
		23122,
		122
	],
	"./cakeday.json": [
		66868,
		868
	],
	"./communication.json": [
		10022,
		22
	],
	"./default.json": [
		9711,
		711
	],
	"./efficiency.json": [
		67559,
		559
	],
	"./empathy.json": [
		3446,
		446
	],
	"./friendliness.json": [
		49902,
		902
	],
	"./hacker.json": [
		97080,
		80
	],
	"./knowledge.json": [
		36506,
		506
	],
	"./rocket.json": [
		17070,
		70
	],
	"./skill.json": [
		96411,
		792
	],
	"./treatment.json": [
		2366,
		366
	],
	"./unknown-badge.json": [
		52794,
		794
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 13463;
module.exports = webpackAsyncContext;